
export default {
  name: 'CommonLoading'
}
